export const EntryPath = {
  login: '/',
  forgetPassword: 'forgot-password',
  register: 'register',
  emailVerification: 'register/verify',
  resetPassword: 'reset-password',
};
